<div class="tw-min-h-screen tw-bg-slate-50 tw-py-12 tw-px-4">
  <div class="tw-max-w-4xl tw-mx-auto">

    <div class="tw-mb-8">
      <h1 class="tw-text-2xl tw-font-bold tw-text-slate-900">Detalles de la Empresa</h1>
      <p class="tw-mt-1 tw-text-slate-500 tw-text-sm">Información y vacantes</p>
    </div>

    <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-6">

      <div class="lg:tw-col-span-2 tw-flex tw-flex-col tw-gap-5">

        <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <div class="tw-flex tw-items-center tw-gap-4 tw-mb-4">
            <img loading="lazy" src="{{detallesempresa.logo}}" alt="{{detallesempresa.nombre}}" title="{{detallesempresa.nombre}}"
              class="tw-w-16 tw-h-16 tw-rounded-xl tw-object-cover tw-border tw-border-slate-100">
            <div>
              <h2 class="tw-text-xl tw-font-bold tw-text-slate-900">{{detallesempresa.nombre}}</h2>
              <p class="tw-text-sm tw-text-slate-500 tw-flex tw-items-center tw-gap-1 tw-mt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-3.5 tw-h-3.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"/></svg>
                {{detallesempresa.estado}}, {{detallesempresa.ciudad}}
              </p>
            </div>
          </div>
          <div class="tw-flex tw-items-baseline tw-gap-2 tw-text-sm tw-text-slate-600 tw-mb-1">
            <span class="tw-font-medium tw-text-slate-700">Razón social:</span>
            <span>{{detallesempresa.razonSocial}}</span>
          </div>
        </div>

        <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-mb-3">Contacto</h3>
          <ul class="tw-flex tw-flex-col tw-gap-2">
            <li class="tw-flex tw-items-center tw-gap-2 tw-text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4 tw-text-slate-400 tw-shrink-0"><path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"/></svg>
              <a href="{{detallesempresa.paginaWeb}}" target="_blank" class="tw-text-blue-600 hover:tw-underline">{{detallesempresa.paginaWeb}}</a>
            </li>
            <li class="tw-flex tw-items-center tw-gap-2 tw-text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4 tw-text-slate-400 tw-shrink-0"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/></svg>
              <span class="tw-text-slate-600">{{detallesempresa.correo}}</span>
            </li>
            <li class="tw-flex tw-items-center tw-gap-2 tw-text-sm">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="tw-w-4 tw-h-4 tw-text-slate-400 tw-shrink-0"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"/></svg>
              <span class="tw-text-slate-600">{{detallesempresa.telefono}}</span>
            </li>
          </ul>
        </div>

        <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-mb-3">Descripción</h3>
          <p class="tw-text-sm tw-text-slate-600 tw-leading-relaxed">{{ detallesempresa.descripcion}}</p>
        </div>

        <div *ngIf="!usuario.role">
          <a routerLink="/registrarse"
            class="tw-block tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-text-center tw-no-underline tw-transition hover:tw-bg-blue-700"
            style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
            Aplicar ahora
          </a>
        </div>
        <div *ngIf="usuario.role == 'candidato'">
          <a (click)="routerLinkVacantesEmpresa(idEmpresaTemp)"
            class="tw-block tw-w-full tw-py-2.5 tw-rounded-xl tw-bg-blue-600 tw-text-white tw-font-semibold tw-text-sm tw-text-center tw-no-underline tw-cursor-pointer tw-transition hover:tw-bg-blue-700"
            style="box-shadow:0 1px 3px rgba(37,99,235,.3)">
            Aplicar ahora
          </a>
        </div>

      </div>

      <div class="tw-flex tw-flex-col tw-gap-5">

        <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <div *ngIf="vacantescategoriasize != 0">
            <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-mb-3">Vacantes por categoría</h3>
            <ul class="tw-flex tw-flex-col tw-gap-2" *ngFor="let categorias of vacantescategorias">
              <li class="tw-flex tw-items-center tw-justify-between tw-text-sm">
                <span class="tw-text-slate-700">{{categorias.nombreCategoria}}</span>
                <span class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-blue-50 tw-text-blue-700 tw-text-xs tw-font-medium">{{categorias.contadorVacantes}}</span>
              </li>
            </ul>
          </div>
          <div *ngIf="vacantescategoriasize == 0">
            <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-mb-3">Vacantes Publicadas</h3>
            <ul *ngIf="vacantespublicadasExito" class="tw-flex tw-flex-col tw-gap-2">
              <li class="tw-flex tw-items-center tw-justify-between tw-text-sm">
                <span class="tw-text-slate-700">{{vacantespublicadas.nombreEmpresa}}</span>
                <span class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-blue-50 tw-text-blue-700 tw-text-xs tw-font-medium">{{vacantespublicadas.numeroVacantes}}</span>
              </li>
            </ul>
            <p *ngIf="!vacantespublicadasExito" class="tw-text-sm tw-text-slate-500">No se encontraron vacantes activas</p>
          </div>
        </div>

        <div class="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-p-6" style="box-shadow:0 1px 3px rgba(0,0,0,.06)">
          <h3 class="tw-text-sm tw-font-semibold tw-text-slate-800 tw-mb-3">Vacantes en Estados</h3>
          <ul class="tw-flex tw-flex-col tw-gap-2" *ngFor="let estados of vacantesestado">
            <li class="tw-flex tw-items-center tw-justify-between tw-text-sm">
              <span class="tw-text-slate-700">{{estados.nombreEstado}}</span>
              <span class="tw-px-2 tw-py-0.5 tw-rounded-full tw-bg-slate-100 tw-text-slate-600 tw-text-xs tw-font-medium">{{estados.contadorVacantes}}</span>
            </li>
          </ul>
        </div>

      </div>

    </div>

  </div>
</div>
